import axiosInstance from "./axios-index";

const token = localStorage.getItem("admin_token");
// 퍄트너스 아이디 중복 체크(이메일)
export const getCheckEmail = async (data) => {
  return await axiosInstance
    .post(`/partners/check-id`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};
// 문자 전송
export const smsSend = async (phone_num) => {
  return await axiosInstance
    .post(`/sms/smsSend`, {
      lang: "ko",
      phone_numb: phone_num,
      platform: "WEB_PARTNERS",
      check: false,
    })
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 문자 인증번호 인증
export const smsCert = async (data) => {
  return await axiosInstance
    .post(`/sms/appSmsCert`, {
      lang: "ko",
      ...data,
    })
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 회원가입
export const createSignUp = async (data) => {
  return await axiosInstance
    .post(`/partners/sign-up`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 아이디 찾기(이메일)
export const getId = async (data) => {
  return await axiosInstance
    .post(`/partners/get/id`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};
// 비밀번호 찾기(변경)
export const updatePassword = async (data) => {
  return await axiosInstance
    .post(`/partners/update/password`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 로그인
export const getSignIn = async (data) => {
  return await axiosInstance
    .post(`/partners/sign-in`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 기간별 리포트
export const getRebateReportByPeriod = async (data) => {
  return await axiosInstance
    .post(`/partners/get/rebate-report/by-period`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};
// 정산 리포트
export const getRebateReport = async (data) => {
  return await axiosInstance
    .post(`/partners/get/rebate-report`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};
// 퍄트너스 게시글/공지사항 가져오기
export const getBoard = async (data) => {
  return await axiosInstance
    .post(`/partners/get/board`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 기본 유저 정보 가져오기
export const getVerifyInfo = async () => {
  return await axiosInstance
    .post(`/partners/verify-user`)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 퍄트너스 회원 정보 가져오기
export const getUserInfo = async () => {
  return await axiosInstance
    .post(`/partners/get/user-info`)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 퍄트너스 회원 정보 수정하기
export const modifyUserInfo = async (data) => {
  return await axiosInstance
    .post(`/partners/update/user`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 퍄트너스 문의하기(문의 메일 발송)
export const sendContactEmail = async (data) => {
  return await axiosInstance
    .post(`/partners/send/contact-email`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 일사 가입 회원사 명단 검색
export const getCompanyList = async (data) => {
  return await axiosInstance
    .post(`/partners/get/company-list`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};

// 퍄트너스 회원 탈퇴
export const getWithdrawalUser = async (data) => {
  return await axiosInstance
    .post(`/partners/withdrawal-user`, data)
    .then((response) => {
      return response.data.result;
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });
};
